skrilla.service('loginService', function($window, $location, searchService, adminService, modalService) {

    var login = function(loginDetails){
        searchService.login(loginDetails ,function (response) {
            if (response.status == 200 || response.status == 204) {
                var path = $location.search().returnUrl;
                $window.localStorage.token = "Bearer " + response.data.token;
                adminService.getAdmin(true);
                //notificationsService.begin(response.data.id);
              if (response.data.mfa == 'NONE') {
                modalService.openModal("views/totp/totpModal.html", true, 'lg', true, true)
              }
                if (path && path.length > 0) {
                    console.log("Return " + path);
                    location.href = "/#" + path;
                }
                else {
                    console.log("go home");
                    location.href = "/#/admin/home";
                }
            }
        }, function(response) {
            delete $window.localStorage.token;
            delete $window.localStorage.fbToken;
            swal("Error!", response.data.errors && response.data.errors[0] && response.data.errors[0].message)
        });
    }

    var logout = function(){
        searchService.logout();
        delete $window.localStorage.token;
        delete $window.localStorage.fbToken;
        location.href = "/#/login";
    }

    return {
        login: login,
        logout: logout
    };
});
